import React from "react";
import { connect } from "react-redux";
import { notification } from "../../services";
import { checkAuth } from "../../reducers/user/actions";
import { authRedirect } from "../../helpers";
import { Form } from "../../lib";
import { AppState } from "../../store";

const mapState = (state: AppState) => ({ user: state.user });
const mapDispatch = { checkAuth };

type StateProps = ReturnType<typeof mapState>;
type DispatchProps = typeof mapDispatch;
type Props = StateProps & DispatchProps;
type State = {};
type Snapshot = Props & State;

class LoginForm extends React.Component<Props> {
    componentDidMount() {
        authRedirect(this.props);
    }

    componentDidUpdate(
        _prevProps: Props,
        _prevState: State,
        _snapshot: Snapshot
    ) {
        authRedirect(this.props);
    }

    order = ["email", "password"];

    fields = {
        email: {
            type: "email",
        },
        password: {
            type: "password",
        },
    };

    constraints = {
        email: {
            presence: { message: "emailRequired" },
            email: { message: "emailInvalid" },
        },

        password: {
            presence: { message: "passwordRequired" },
            length: {
                minimum: 6,
                message: "passwordMinChars",
            },
        },
    };

    onSubmit = (values: Record<string, any>) => {
        try {
            this.props.checkAuth(values);
        } catch (e) {
            notification.set("loginForm.failed", "f");
        }
    };

    render() {
        return (
            <Form
                id="login"
                order={this.order}
                fields={this.fields}
                constraints={this.constraints}
                focusOnFirst={true}
                onSubmit={this.onSubmit}
            />
        );
    }
}

export default connect(mapState, mapDispatch)(LoginForm);
